module.exports = __webpack_public_path__ + "static/media/smartdealer-mobile.2e07f904.png";